import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.map.js";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@emotion/react';
import { Paper } from 'components/UI';
import EChart from '../shared/EChart';
import { jsx as ___EmotionJSX } from "@emotion/react";

var LatePaymentsBuckets = function LatePaymentsBuckets(_ref) {
  var overdueSummary = _ref.overdueSummary,
      _ref$currency = _ref.currency,
      currency = _ref$currency === void 0 ? 'EUR' : _ref$currency;
  var theme = useTheme();
  var option = useMemo(function () {
    var _buckets$1_3_days$amo, _buckets$1_3_days, _buckets$4_7_days$amo, _buckets$4_7_days, _buckets$8_30_days$am, _buckets$8_30_days, _buckets$over_30_days, _buckets$over_30_days2, _buckets$1_3_days$cou, _buckets$1_3_days2, _buckets$4_7_days$cou, _buckets$4_7_days2, _buckets$8_30_days$co, _buckets$8_30_days2, _buckets$over_30_days3, _buckets$over_30_days4;

    if (!(overdueSummary !== null && overdueSummary !== void 0 && overdueSummary.by_bucket)) return null;
    var buckets = overdueSummary.by_bucket;
    var categories = ['1-3 дни', '4-7 дни', '8-30 дни', '30+ дни'];
    var amounts = [Number((_buckets$1_3_days$amo = (_buckets$1_3_days = buckets['1_3_days']) === null || _buckets$1_3_days === void 0 ? void 0 : _buckets$1_3_days.amount) !== null && _buckets$1_3_days$amo !== void 0 ? _buckets$1_3_days$amo : 0), Number((_buckets$4_7_days$amo = (_buckets$4_7_days = buckets['4_7_days']) === null || _buckets$4_7_days === void 0 ? void 0 : _buckets$4_7_days.amount) !== null && _buckets$4_7_days$amo !== void 0 ? _buckets$4_7_days$amo : 0), Number((_buckets$8_30_days$am = (_buckets$8_30_days = buckets['8_30_days']) === null || _buckets$8_30_days === void 0 ? void 0 : _buckets$8_30_days.amount) !== null && _buckets$8_30_days$am !== void 0 ? _buckets$8_30_days$am : 0), Number((_buckets$over_30_days = (_buckets$over_30_days2 = buckets.over_30_days) === null || _buckets$over_30_days2 === void 0 ? void 0 : _buckets$over_30_days2.amount) !== null && _buckets$over_30_days !== void 0 ? _buckets$over_30_days : 0)];
    var counts = [(_buckets$1_3_days$cou = (_buckets$1_3_days2 = buckets['1_3_days']) === null || _buckets$1_3_days2 === void 0 ? void 0 : _buckets$1_3_days2.count) !== null && _buckets$1_3_days$cou !== void 0 ? _buckets$1_3_days$cou : 0, (_buckets$4_7_days$cou = (_buckets$4_7_days2 = buckets['4_7_days']) === null || _buckets$4_7_days2 === void 0 ? void 0 : _buckets$4_7_days2.count) !== null && _buckets$4_7_days$cou !== void 0 ? _buckets$4_7_days$cou : 0, (_buckets$8_30_days$co = (_buckets$8_30_days2 = buckets['8_30_days']) === null || _buckets$8_30_days2 === void 0 ? void 0 : _buckets$8_30_days2.count) !== null && _buckets$8_30_days$co !== void 0 ? _buckets$8_30_days$co : 0, (_buckets$over_30_days3 = (_buckets$over_30_days4 = buckets.over_30_days) === null || _buckets$over_30_days4 === void 0 ? void 0 : _buckets$over_30_days4.count) !== null && _buckets$over_30_days3 !== void 0 ? _buckets$over_30_days3 : 0];
    return {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        },
        formatter: function formatter(params) {
          var idx = params[0].dataIndex;
          return "".concat(categories[idx], "<br/>\u0421\u0443\u043C\u0430: ").concat(amounts[idx].toFixed(2), " ").concat(currency, "<br/>\u0411\u0440\u043E\u0439: ").concat(counts[idx]);
        }
      },
      grid: {
        left: 10,
        right: 20,
        top: 10,
        bottom: 30,
        containLabel: true
      },
      xAxis: {
        type: 'value',
        axisLabel: {
          color: theme.gray400,
          fontSize: 11
        },
        splitLine: {
          lineStyle: {
            color: theme.gray100
          }
        }
      },
      yAxis: {
        type: 'category',
        data: categories,
        axisLabel: {
          color: theme.gray500,
          fontSize: 12
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        }
      },
      series: [{
        type: 'bar',
        data: amounts.map(function (val, i) {
          return {
            value: val,
            itemStyle: {
              color: i < 2 ? theme.warning : theme.error
            }
          };
        }),
        barWidth: 20
      }]
    };
  }, [overdueSummary, theme, currency]);
  return ___EmotionJSX(Paper, {
    header: "\u041F\u0440\u043E\u0441\u0440\u043E\u0447\u0438\u044F \u043F\u043E \u0433\u0440\u0443\u043F\u0438",
    noPadding: true,
    padding: "1em"
  }, ___EmotionJSX(EChart, {
    option: option,
    height: 220
  }));
};

LatePaymentsBuckets.propTypes = {
  overdueSummary: PropTypes.object,
  currency: PropTypes.string
};
export default LatePaymentsBuckets;